import React, { useEffect, useState } from 'react';
import VesselStayChart from '../VesselStayChart';
import FuelConsumptionChart from '../FuelConsumptionChart';
import Co2Emmission from '../Co2EmmissionCii';
import { Card, CardHeader, Row, Col, CardBody, Label } from 'reactstrap';
import { queryKeyes } from 'shared/queryKeys';
import { useQuery } from 'react-query';
import { loadCIIData, loadCiiAssesmentGraphData } from 'VesselMaster/vesselMaster.hooks';
import Loading from 'Components/Loading';
import ErrorComponent from 'Components/ErrorComponent';
// import { setFifteenDays, setNinetyDays, setThirtyDays } from 'Store/Generic/ReportingSlice';
import apiGlobal from 'global/api.global';
import CIIChart from '../chart';

const CIIAssessmentPartial = (vesselId: any) => {
    const [ciiGraph, setCIIGraph] = useState<Array<any>>([]);
    const [maxRating, setMaxRating] = useState(0);

    const { data: ciiassesmentData, isLoading: ciiAssesmentGraphLoading, isError: ciiAssesmentGraphError } = useQuery([
        queryKeyes.vessel.CIIAssessmentData.key, parseInt(vesselId.vesselId)
    ], async () => { return await loadCiiAssesmentGraphData(parseInt(vesselId.vesselId)) })
    // const record = Vessels.find((rec: any) => rec.id === vesselId.vesselId);

    const { data: ciiData } = useQuery([
        queryKeyes.vessel.CIIData.key, parseInt(vesselId.vesselId)
    ], async () => { return await loadCIIData(parseInt(vesselId.vesselId)) })

    useEffect(() => {
        const loadData = async () => {
            await apiGlobal.get(`cii_graph/get_cii_graph_data_by_vessel/?vessel_id=${vesselId.vesselId}`).then(response => {
                let arr: any[] = response.data.filter((item: any, index: number) =>
                    index < response.data.length - 1 && item?.reporting_date?.toString().substring(0, 10) !==
                    response.data[index + 1]?.reporting_date?.toString().substring(0, 10));
                for (let i = arr.length - 1; i <= 365; i++) {
                    const dt = new Date(arr[i]?.reporting_date);
                    const timeStamp = new Date(dt.setDate(dt.getDate() + 1));
                    arr[i].reporting_date = `${timeStamp.getFullYear()}-${timeStamp.getMonth() + 1}-${timeStamp.getDate()}`;
                    arr.push({ ...arr[i] });
                }
                arr = arr.map((item, index) => {
                    return {
                        ...item,
                        index: index
                    };
                });
                setCIIGraph(arr);
                setMaxRating(arr.reduce((max, dt) => (dt.cii_rating > max ? dt.cii_rating : max), 0));
            }).catch(err => {
                console.log(err)
            })
        }; loadData();
    }, [vesselId.vesselId])

    if (ciiAssesmentGraphLoading) {
        return <Loading message={'Loading required data!'} />
    }

    if (ciiAssesmentGraphError) {
        return <ErrorComponent message={'Unable to load required data!'} />
    }
    return (
        <>
            <Row>
                <Col lg={4}>
                    <Row className='mb-2'>
                        <Col lg={12}>
                            <h6 className='mb-1'>Without adjustments</h6>
                        </Col>
                        <Col lg={4}>
                            <span>Ref. CII - <strong>{ciiData?.without_adjustment_data?.reference_cii?.toFixed(2)}</strong></span>
                        </Col>
                        <Col lg={4}>
                            <span>Att. CII - <strong>{ciiData?.without_adjustment_data?.attained_cii?.toFixed(2)}</strong></span>
                        </Col>
                    </Row>
                    <Row className='mb-2'>
                        <Col lg={4}>
                            <span>Req. CII - <strong>{ciiData?.without_adjustment_data?.required_cii?.toFixed(2)}</strong></span>
                        </Col>
                        <Col lg={4}>
                            <span>CII ratio - <strong>{ciiData?.without_adjustment_data?.cii_rating?.toFixed(2)}</strong></span>
                        </Col>
                    </Row>
                </Col>
                <Col lg={2}>
                    <div className={`CII-rating-${ciiData?.without_adjustment_data?.cii_grade} card-height-3-8 d-flex align-items-center`}>
                        {ciiData?.with_sts_cii_adjustment_data?.cii_grade === 'C' ?
                            <Label className="align-self-center wid-data-C" id='rating'>{ciiData?.without_adjustment_data?.cii_grade}</Label> :
                            <Label className="align-self-center wid-data" id='rating'>{ciiData?.without_adjustment_data?.cii_grade}</Label>
                        }
                    </div>
                </Col>
                <Col lg={3}>
                    <Row className='mb-2'>
                        <Col lg={12}>
                            <h6 className='mb-1'>With adjustments</h6>
                        </Col>
                        <Col lg={6}>
                            <span>Att. CII - <strong>{ciiData?.with_sts_cii_adjustment_data?.attained_cii?.toFixed(2)}</strong></span>
                        </Col>
                    </Row>
                    <Row className='mb-2'>
                        <Col lg={6}>
                            <span>CII ratio - <strong>{ciiData?.with_sts_cii_adjustment_data?.cii_rating?.toFixed(2)}</strong></span>
                        </Col>
                    </Row>
                </Col>
                <Col lg={2}>
                    <div className={`CII-rating-${ciiData?.with_sts_cii_adjustment_data?.cii_grade} card-height-3-8 d-flex align-items-center`}>
                        {ciiData?.without_adjustment_data?.cii_grade === 'C' ?
                            <Label className="align-self-center wid-data-C" id='rating'>{ciiData?.with_sts_cii_adjustment_data?.cii_grade}</Label> :
                            <Label className="align-self-center wid-data" id='rating'>{ciiData?.with_sts_cii_adjustment_data?.cii_grade}</Label>
                        }
                    </div>
                </Col>
            </Row>
            <Row className='mt-1'>
                <Col lg={6}>
                    <Card>
                        <CardHeader className='p-2'>
                            <h6 className='mb-0'>Vessel stay chart</h6>
                        </CardHeader>
                        <CardBody className='p-2'>
                            <VesselStayChart pieChartData={ciiassesmentData} />
                        </CardBody>
                    </Card>
                </Col>
                <Col lg={6}>
                    <Card>
                        <CardHeader className='p-2'>
                            <h6 className='mb-0'>Fuel consumption chart</h6>
                        </CardHeader>
                        <CardBody className='p-2'>
                            <FuelConsumptionChart pieChartData={ciiassesmentData} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg={6}>
                    <Card>
                        <CardHeader className='p-2'>
                            <h6 className='mb-0'>CO<sub>2</sub> emmission chart</h6>
                        </CardHeader>
                        <CardBody className='p-2'>
                            <Co2Emmission pieChartData={ciiassesmentData} VesselID={vesselId} />
                        </CardBody>
                    </Card>
                </Col>
                <Col lg={6}>
                    <Card>
                        <CardHeader className='p-2'>
                            <h6 className='mb-0'>CII trend</h6>
                        </CardHeader>
                        <CardBody className='p-2'>
                            <CIIChart graphData={ciiGraph} maxRating={maxRating} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CIIAssessmentPartial